module.exports = __webpack_public_path__ + "media/MRI15.d8268a8b.mp3";